import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ExternalReceptacleLinkColumn,
    ExternalConsignmentLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'PREDES',
      columns: [
        new TextColumn('Sender', 'predes.sender'),
        new TextColumn('Receiver', 'predes.receiver'),
        new TextColumn('Sending mailbox', 'predes.sendingMailbox'),
        new TextColumn('Receiving mailbox', 'predes.receivingMailbox'),
      ],
    },
    {
      Header: 'Origin IMPC',
      columns: [
        new TextColumn('Operator', 'origin.operator'),
        new TextColumn('Code', 'origin.impc'),
      ],
    },
    {
      Header: 'Destination IMPC',
      columns: [
        new TextColumn('Operator', 'destination.operator'),
        new TextColumn('Code', 'destination.impc'),
      ],
    },
    {
      Header: 'Despatch',
      columns: [
        new TextColumn('Mail category', 'despatch.mailCategory'),
        new TextColumn('Mail class', 'despatch.mailClass'),
        new DateTimeColumn('Despatch closed', 'despatch.closeDate'),
      ],
    },
    {
      Header: 'Receptacle',
      columns: [
        new ExternalReceptacleLinkColumn(new TextColumn('ID', 'receptacle.id').withWidth(275)),
        new TextColumn('ID in PRECON', 'receptacle.idInPrecon'),
        new TextColumn('Core ID in PRECON', 'receptacle.coreIdInPrecon'),
      ],
    },
    {
      Header: 'Consignment',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('ID', 'consignment.id')),
      ],
    },
  ];
};
